(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),

        orginialID : $('.pg-project--first-load').data('original-id'),


        splitText : {},


        loadNextProject: function(project) {
            __.fetch = new ScrollMagic.Scene({ triggerElement: project, duration: 1, offset: $(project).find('.pg-project-banner').height(), triggerHook: 1, reverse: false, })
            .on('start', function (event) {
                var trigger  = $(this.triggerElement());
                var url = trigger.data('url');
                if(window.location.href !== url) {
                    __.setURL(url);
                    if(trigger.hasClass('j-project--not_loaded') && trigger.data('next-id') !== __.orginialID){
                        trigger.addClass('j-project--loading-page');
                        __.getNextProject(url);
                    }
                }
            }).addTo(__.controller);
        },
        urlUpdater: function(project) {
            new ScrollMagic.Scene({ triggerElement: project, duration: 1, offset: (-1 * ($(project).prev().find('.pg-project--next-project').height() + 200)) , triggerHook: 0, reverse: true, })
            .on('start', function (event) {
                var trigger  = $(this.triggerElement());
                if(event.scrollDirection === "REVERSE" ){
                   trigger  = $(this.triggerElement()).prev();
                }
                var url = trigger.data('url');
                $('.j-project--trigger').removeClass('pg-trigger--active');
                trigger.addClass('pg-trigger--active');
                __.setURL(url);
            }).addTo(__.controller);
        },
        infoBar: function(project) {

            jProject = $(project);

            new ScrollMagic.Scene({ triggerElement: project, duration: jProject.height(), offset: 0 , triggerHook: 1, reverse: true, })
            // .addIndicators({'name': 'InfoBar '})
            .setPin(jProject.find('.j-project--info-bar').get(0))
            .addTo(__.controller);
        },
        resetProjectTrigger: function(){
            // __.nextPostScene.destroy(true);

        },
        // Sets the url in the location bar to match the new content
        setURL: function (url) {
            var stateObj = { url: url, innerhtml: document.body.innerHTML };
            history.pushState(stateObj, url, url);
        },
        // adds fetched results to page
        addNextProject: function(results){
            // Remove spinner
            $('.pg-project--up-next--spinner').detach();
            $('.j-project--not_loaded').removeClass('j-project--not_loaded').parents('.j-project--trigger').addClass('isLoaded');
            // get new content
            if(results.find('.pg-project--next--project--introduction').data('next-id') === __.orginialID ){
                results.find('.pg-project--next-project').remove();
            }
            var newPostContent = results.find('.j-project--body').html();
            // add it to the old content
            $('.j-project--body').append(newPostContent);
            // Setup the new trigger
            var nextProject = $('.j-project--not_loaded');

            __.loadNextProject(nextProject.get(0));
            var parent = nextProject.parents('.j-project--trigger').get(0);
            __.pageEffects( $('j-project--trigger').last() );
            __.urlUpdater(parent);
            // __.infoBar(parent);

        },
        // Fetch results page
        getNextProject: function(url){
            // ajax request a page
            __.setURL(url);
            __.ajax = jQuery.ajax({
                dataType: 'text',
                url: url,
                success: function (rawhtml) {
                // display results
                    __.fetch.destroy();
                    __.addNextProject($(rawhtml));
                },
                error: function(){
                }
            });
        },

        // Function that runs on load
        loadAnimations: function() {
            $('.j-project--not_loaded').each(function(){
                __.loadNextProject(this);
            });
            __.pageLoadEffects();

            __.pageEffects($('.j-project--trigger'));
        },
        pageLoadEffects: function(){
            var timeline = new TimelineMax();


            if (__.global.screen === "large") {
                __.splitText.intro =  __.global.splitText( $('.pg-project--first-load').find('.pg-project-intro--name') );
                __.splitText.title =  __.global.splitText( $('.pg-project--first-load').find('.pg-project-intro--title') );
                __.splitText.text =  __.global.splitText( $('.pg-project--first-load').find('.pg-project-intro--text') );


                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.2')
                .add(TweenMax.from($('.pg-project--first-load').find('.pg-project-banner'), 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )

                .add(TweenMax.from($('.pg-project--first-load').find('.s-highlight__side'), 0.2, {width: 0}) );
                __.global.staggerDisplay( __.splitText.intro, timeline);
                __.global.staggerDisplay( __.splitText.title, timeline);
                __.global.staggerDisplay( __.splitText.text, timeline);
                timeline
                .call(function() {
                    __.splitText.intro.revert();
                    __.splitText.title.revert();
                    __.splitText.text.revert();
                })
                .add(TweenMax.from('.pg-project--info-banner', 0.4, __.global.animations.fade.up) )
                .add(TweenMax.from('.pg-project-content--container', 0.4, __.global.animations.fade.up) )
                .call(function() {
                    __.global.completeLoadInAnimation();
                });
            }else{

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                .add(TweenMax.from($('.pg-project--first-load').find('.pg-project-banner'), 0.4, __.global.animations.fade.right) )
                .add(TweenMax.from($('.pg-project--first-load').find('.pg-project-intro'), 0.4, __.global.animations.fade.up) )
                .add(TweenMax.from('.j-project--body', 0.4, __.global.animations.fade.up) )
                .call(function() {
                    __.global.completeLoadInAnimation();
                });
            }

            timeline.play(); //
        },
        pageEffects: function(block){
            if (__.global.screen === "large") {
                __.loadImageBlocks(block);
                __.loadImageGridBlocks(block);
                __.loadvideoBlocks(block);
                __.loadTripleImageBlocks(block);
                __.loadImageContentBlocks(block);
                __.controller.update(true);
            }
        },
        loadImageBlocks : function(blocks){
            blocks.find('.pg-project-block--image').each(function(){
                var block = $(this);
                new ScrollMagic.Scene({
                    duration: 200,
                    offset: 150,
                    triggerHook: 1,
                    reverse: false,
                    triggerElement: this
                })
                .setTween(TweenMax.from(this, 1, __.global.animations.fade.up) )
                .addTo(__.controller);
            });
        },
        loadImageGridBlocks : function(blocks){
            blocks.find('.pg-project-block--image-grid').each(function(){
                var block = $(this);
                new ScrollMagic.Scene({
                    duration: 400,
                    offset: 200,
                    triggerHook: 1,
                    reverse: false,
                    triggerElement: this
                })
                .setTween(TweenMax.staggerFrom(block.find('.pg-project-block--image-grid--image').toArray(), 1, __.global.animations.fade.up, 0.3 ) )
                .addTo(__.controller);
            });
        },
        loadvideoBlocks : function(blocks){
            blocks.find('.pg-project-block--video').each(function(){
                var block = $(this);
                var timeline = new TimelineMax();
                timeline
                    .add(TweenMax.from(this, 1, __.global.animations.fade.up), '0' )
                    .add(TweenMax.from( block.find( '.pg-project-block--video--play'  ), 0.5, {opacity: 1 }), '-=0.25' )
                ;
                new ScrollMagic.Scene({
                    duration: 350,
                    offset: 150,
                    triggerHook: 1,
                    reverse: false,
                    triggerElement: this
                })
                .setTween(timeline )
                .addTo(__.controller);
            });
        },
        loadTripleImageBlocks : function(blocks){
            blocks.find('.pg-project-block--triple-image').each(function(){
                var block = $(this);
                var altTimeline = new TimelineMax();
                altTimeline
                .add(TweenMax.fromTo( block.find( '.pg-project-block--triple-image--image__one' ), 1, {opacity: -2, top: '600px'}, {opacity: 4, top: '0'}) )
                .add(TweenMax.fromTo( block.find( '.pg-project-block--triple-image--image__two' ), 1, {opacity: -1.5, top: '400px'}, {opacity: 4, top: '0'}), '0' )
                .add(TweenMax.fromTo( block.find( '.pg-project-block--triple-image--image__three' ), 1, {opacity: -2.5, top: '800px'}, {opacity: 4, top: '0'}), '0' )
                ;
                new ScrollMagic.Scene({
                    duration: $(window).height(),
                    offset: 150,
                    triggerHook: 1,
                    triggerElement: this
                })
                .setTween( altTimeline )
                .addTo(__.controller);
            });
        },
        loadImageContentBlocks : function(blocks){
            blocks.find('.pg-project-block--image-content').each(function(){
                var block = $(this);
                var timeline = new TimelineMax();
                timeline
                    .add(TweenMax.from( block.find( '.pg-project-block--image-content--image' ), 0.4, __.global.animations.fade.up))
                ;
                new ScrollMagic.Scene({
                    duration: 300,
                    offset: 150,
                    triggerHook: 1,
                    reverse: false,
                    triggerElement: this
                })
                .setTween( timeline )
                .addTo(__.controller);
            });
        },



        // Function to call to setup functionality
        setup: function() {
            __.loadAnimations();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.caseStudy = __;
})(jQuery); // Fully reference jQuery after this point.